// extracted by mini-css-extract-plugin
export default {"p":"styles_p__NB2xu"};